import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

const LandingPage = lazy(() => import('../containers/LandingPage'));

const SignIn = lazy(() => import('../containers/Patient/SignIn'));
const SignUp = lazy(() => import('../containers/Patient/SignUp'));
const Forgot = lazy(() => import('../containers/Patient/Forgot'));

const ProviderSignIn = lazy(() => import('../containers/Provider/SignIn'));
const ProviderForgot = lazy(() => import('../containers/Provider/Forgot'));

import { StyledMainLayoutContainer, StyledContentContainer } from '../components/MainLayout/style';

// import { getSubDomain, getOriginDomain, getDomain } from '../utils/utils';

const PublicRoute = () => {
    return (
        <StyledMainLayoutContainer>
            <StyledContentContainer>
                {['app', 'dev-app', 'stg-app'].includes(window.location.host.split('.')[0]) ? (
                    <Switch>
                        <Route exact path="/signin" component={SignIn} />
                        <Route exact path="/signup" component={SignUp} />
                        <Route exact path="/forgot" component={Forgot} />
                        <Route exact path="/provider/signin" component={ProviderSignIn} />
                        <Route exact path="/provider/forgot" component={ProviderForgot} />

                        <Route path="/provider">
                            <Redirect to="/provider/signin" />
                        </Route>
                        <Route path="*">
                            <Redirect to="/signin" />
                        </Route>
                    </Switch>
                ) : (
                    <Switch>
                        <Route exact path="/" component={LandingPage} />
                        <Route path="*">
                            <Redirect to="/" />
                        </Route>
                    </Switch>
                )}
            </StyledContentContainer>
        </StyledMainLayoutContainer>
    );
};

export default PublicRoute;
